module.exports = __webpack_public_path__ + "static/media/dropIcon.09eaabb3.svg";